import Upsertable from '@/models/Upsertable'
import { useFieldStore } from '@/stores/fieldStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Field extends Upsertable {
  static store() {
    return useFieldStore()
  }

  store() {
    return Field.store()
  }

  static all() {
    return Field.store().getAll
  }

  static find(uuid) {
    const obj = Field.store().find(uuid)
    let field = new Field()
    return Object.assign(field, obj)
  }

  static find_all_by_farm_uuid(farm_uuid) {
    return Field.store()
      .all()
      .filter((field) => field.farm_uuid == farm_uuid)
  }

  static findAllByCustomerUuid(customer_uuid) {
    return Field.store()
      .all()
      .filter((field) => field.customer_uuid == customer_uuid)
  }
}

useModelName(Field, "Field")
ModelRegistry.register(Field, "Field")